export class SizingInfo {
    public isSizing: boolean;
    public pageX: number;
    public originalWidth: number;
    public newWidth: number;
    public sizingInProgress: boolean;
}
